<template>
    <div class="cta-large container">
        <NuxtLink :to="link" class="button" :class="color">
            <slot></slot>
        </NuxtLink>
    </div>
</template>

<script setup>
    const props = defineProps({
        color: {
            type: String,
            required: false,
            default: 'turquoise',
        },
        link: {
            type: String,
            required: false,
            default: '/connect',
        },
    });
</script>

<style lang="scss" scoped>
    .cta-large {
        .button {
            display: block;

            &:hover {
                border-color: $turquoise;
                background-color: $turquoise;
                color: white;
                transition: all 0.1s linear;
            }

            @media (min-width: $tablet) {
                width: 100%;
                margin: auto;
            }
        }
    }
</style>
